<template>
  <div id="mission-edit-form">
    <v-card v-for="kelas in kelasList" :key="kelas" flat>
      <!-- Header -->
      <v-card-actions>
        <v-list-item two-line class="pa-0">
          <v-list-item-content class="pa-0">
            <v-list-item-title class="font-weight-bold pb-2">Kelas</v-list-item-title>
            <v-text-field :value="kelas" outlined disabled filled />
          </v-list-item-content>
        </v-list-item>
        <v-spacer></v-spacer>
        <v-btn icon @click="expanded[kelas] = !expanded[kelas]">
          <v-icon>{{ expanded[kelas] ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
        </v-btn>
      </v-card-actions>

      <!-- Expand content -->
      <v-expand-transition>
        <div v-show="expanded[kelas]" class="mx-5">
          <!-- Loop missions -->
          <v-card
            v-for="(mission, mIndex) in missionsByClass[kelas]"
            :key="mIndex"
            flat
            class="mb-5 pa-3"
          >
            <!-- Feature Name -->
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold pb-2">Fitur</v-list-item-title>
                <v-text-field :value="mission.feature_name" outlined filled disabled />
              </v-list-item-content>
            </v-list-item>

            <!-- Daily -->
            <div>
              <v-checkbox
                v-model="mission.is_daily"
                label="Daily"
                @change="handleDailyChange(mission)"
                :disabled="!allowDaily(mission.id)"
              />
              <v-row v-if="mission.is_daily" dense>
                <v-col cols="6">
                  <v-text-field v-model="mission.daily_target" label="Misi per hari" outlined />
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="mission.poin_daily" label="Poin per hari" outlined />
                </v-col>
              </v-row>
            </div>

            <!-- Weekly -->
            <div class="mt-3">
              <v-checkbox
                v-model="mission.is_weekly"
                label="Weekly"
                @change="handleWeeklyChange(mission)"
              />
              <v-row v-if="mission.is_weekly" dense>
                <v-col cols="6">
                  <v-text-field v-model="mission.week_one_target" label="Minggu 1" outlined />
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="mission.week_two_target" label="Minggu 2" outlined />
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="mission.week_three_target" label="Minggu 3" outlined />
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="mission.week_four_target" label="Minggu 4" outlined />
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="mission.poin_weekly" label="Poin per minggu" outlined />
                </v-col>
              </v-row>
            </div>
          </v-card>

          <!-- Save button -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="submit(kelas)">
              Simpan Misi Kelas {{ kelas }}
            </v-btn>
          </v-card-actions>
        </div>
      </v-expand-transition>
    </v-card>

    <app-spinner v-if="isLoading" />
  </div>
</template>


<script>
import Spinner from "@/modules/global/components/plugins/Spinner";
import AmbisMeterService from "@/modules/ambis_meter/services/ambis_meter.js";

export default {
    name: "mission-edit-form",
    components: { "app-spinner": Spinner },

    data() {
        return {
            isLoading: false,
            expanded: {},
            periode_id: this.$route.query.id,
            kelasList: [4, 5, 6, 7, 8, 9, 10, 11, 12],
            missionsTemplate: [
                { id: 1, feature_name: "Try Out", mission_id: 0, is_daily: false, poin_daily: 0, daily_target: 0, is_weekly: false, poin_weekly: 0, week_one_target: 0, week_two_target: 0, week_three_target: 0, week_four_target: 0 },
                { id: 2, feature_name: "Live Class", mission_id: 0, is_daily: false, poin_daily: 0, daily_target: 0, is_weekly: false, poin_weekly: 0, week_one_target: 0, week_two_target: 0, week_three_target: 0, week_four_target: 0 },
                { id: 3, feature_name: "Video", mission_id: 0, is_daily: false, poin_daily: 0, daily_target: 0, is_weekly: false, poin_weekly: 0, week_one_target: 0, week_two_target: 0, week_three_target: 0, week_four_target: 0 },
                { id: 4, feature_name: "Ambis Recharge", mission_id: 0, is_daily: false, poin_daily: 0, daily_target: 0, is_weekly: false, poin_weekly: 0, week_one_target: 0, week_two_target: 0, week_three_target: 0, week_four_target: 0 },
                { id: 5, feature_name: "Konsultasi", mission_id: 0, is_daily: false, poin_daily: 0, daily_target: 0, is_weekly: false, poin_weekly: 0, week_one_target: 0, week_two_target: 0, week_three_target: 0, week_four_target: 0 },
                { id: 6, feature_name: "Latihan Soal", mission_id: 0, is_daily: false, poin_daily: 0, daily_target: 0, is_weekly: false, poin_weekly: 0, week_one_target: 0, week_two_target: 0, week_three_target: 0, week_four_target: 0 },
                { id: 7, feature_name: "Modul", mission_id: 0, is_daily: false, poin_daily: 0, daily_target: 0, is_weekly: false, poin_weekly: 0, week_one_target: 0, week_two_target: 0, week_three_target: 0, week_four_target: 0 }
            ],
            missionsByClass: {}
        };
    },

    created() {
        this.kelasList.forEach(k => {
            this.$set(this.expanded, k, false);
            this.$set(this.missionsByClass, k, JSON.parse(JSON.stringify(this.missionsTemplate)));
        });
    },

    mounted() {
        if (this.periode_id) this.getDetailMission();
    },

    methods: {
        allowDaily(featureId) {
            // disable daily for Live Class (2) and Ambis Recharge (4)
            return ![2, 4].includes(featureId);
        },

        handleWeeklyChange(mission) {
            if (!mission.is_weekly) {
                mission.poin_weekly = 0;
                mission.week_one_target = 0;
                mission.week_two_target = 0;
                mission.week_three_target = 0;
                mission.week_four_target = 0;
            }
        },

        handleDailyChange(mission) {
            if (!mission.is_daily) {
                mission.poin_daily = 0;
                mission.daily_target = 0;
            }
        },

        async getDetailMission() {
            this.isLoading = true;

            await AmbisMeterService.getMissionDetail(this.periode_id, (response) => {
                if (response.success) {
                    response.data.forEach(kelasData => {
                        const kelas = kelasData.kelas;
                        const missions = this.missionsByClass[kelas];
                        if (!missions) return;

                        kelasData.missions.forEach(result => {
                            const mission = missions.find(m => m.id === result.feature_id);
                            if (mission) {
                                mission.mission_id = result.id;
                                mission.is_daily = result.is_daily;
                                mission.poin_daily = result.poin_daily;
                                mission.daily_target = result.daily_target;
                                mission.is_weekly = result.is_weekly;
                                mission.poin_weekly = result.poin_weekly;
                                mission.week_one_target = result.week_one_target;
                                mission.week_two_target = result.week_two_target;
                                mission.week_three_target = result.week_three_target;
                                mission.week_four_target = result.week_four_target;
                            }
                        });
                    });
                }

                this.isLoading = false;
            });
        },


        submit(kelas) {
            const payload = this.missionsByClass[kelas].map(m => ({
                id: m.mission_id && m.mission_id !== 0 ? m.mission_id : null, // null if not yet created
                feature_id: m.id,
                kelas,
                periode_id: this.periode_id,
                is_daily: this.allowDaily(m.id) ? m.is_daily : false,
                poin_daily: this.allowDaily(m.id) ? parseFloat(m.poin_daily) : 0,
                daily_target: this.allowDaily(m.id) ? parseFloat(m.daily_target) : 0,
                is_weekly: m.is_weekly,
                poin_weekly: parseFloat(m.poin_weekly),
                week_one_target: parseFloat(m.week_one_target),
                week_two_target: parseFloat(m.week_two_target),
                week_three_target: parseFloat(m.week_three_target),
                week_four_target: parseFloat(m.week_four_target)
            }));

            this.isLoading = true;

            // Check if any mission already exists (has mission_id from backend)
            const hasExisting = payload.some(p => p.id !== null && p.id !== 0);

            if (hasExisting) {
                // Update existing
                AmbisMeterService.updateMission(this.periode_id, kelas, payload, (result) => {
                    this.$store.commit("showAlert", {
                        message: result.success
                            ? `Misi Kelas ${kelas} berhasil diperbarui!`
                            : "Gagal update misi!",
                        type: result.success ? "success" : "error"
                    });
                    this.isLoading = false;
                });
            } else {
                // Create new
                AmbisMeterService.addMission(payload, (result) => {
                    this.$store.commit("showAlert", {
                        message: result.success
                            ? `Misi Kelas ${kelas} berhasil dibuat!`
                            : "Gagal membuat misi!",
                        type: result.success ? "success" : "error"
                    });
                    this.isLoading = false;
                });
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// MissionEditForm.vue?3879c160